import { Row } from '@devexpress/dx-react-grid';
import { MainPageContainer, UpperInfoContainer } from 'components/PageLayout';
import ReportGrid from 'components/ReportGrid';
import { useWPSiteConnectionsReport } from 'pages/hooks';
import { useMemo } from 'react';
import { formatDateTime } from 'utils/helpers';
import { ReportProps } from '../hooks';
import { AxiosError } from 'axios';
import { errorMessages } from 'api/resources/responseMessages/errorMessages';
import { ReportGridContainer } from 'components/ReportGridContainer';
import { NoReportDataMessage } from 'components/ReportsComponents/NoReportDataMessage';
import { ReportBackButton } from 'components/ReportsComponents/ReportBackButton';
import {
  WP_SITE_CONNECTION_REPORT_GRID_TITLE,
  WP_SITE_CONNECTIONS_REPORT_MESSAGE,
  WP_SITE_CONNECTION_REPORT,
  columns,
  tableColumnExtensions,
} from './constants';
import { ReportHeader } from 'components/ReportsComponents/ReportHeader';
import { reportLogger } from '../reportLogger';

export function WPSiteConnectionsReport({
  setErrorMessage,
  setToast,
}: ReportProps) {
  const { isReportFetching, reportData } =
    useWPSiteConnectionsReport(handleError);

  const rows = useMemo<Row>(() => reportData, [reportData]);

  const isBusy = isReportFetching;

  return (
    <MainPageContainer isLoading={isBusy} direction="column" wrap="nowrap">
      <UpperInfoContainer direction="column">
        <ReportBackButton />
        <ReportHeader
          reportName={WP_SITE_CONNECTION_REPORT}
          infoMessage={WP_SITE_CONNECTIONS_REPORT_MESSAGE}
        />
      </UpperInfoContainer>

      {!isBusy && rows?.length === 0 && <NoReportDataMessage />}

      <ReportGridContainer direction="column">
        <ReportGrid
          rows={rows}
          columns={columns}
          isLoading={isBusy}
          tableColumnExtensions={tableColumnExtensions}
          title={WP_SITE_CONNECTION_REPORT_GRID_TITLE}
          headerTitleForSheet={WP_SITE_CONNECTION_REPORT}
          reportHeaderTagLine={`Report produced on ${formatDateTime(
            new Date()
          )}`}
          showAdditionalExportOptions
          pdfOrientation='l'
        />
      </ReportGridContainer>
    </MainPageContainer>
  );

  function handleError(error: AxiosError) {
    reportLogger(error);
    setErrorMessage(errorMessages.reports('WP site connections Report'));
    setToast(true);
  }
}
